export default "https://cdn.questicon.mathletics.com/assets/images/UPT_Background-06399ac8c97fadd29106c20042377d53.svg";